// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Uq6Jc","container":"styles_container__29eFi","title":"styles_title__XJ_qB","wrapper":"styles_wrapper__zCSnf","answer":"styles_answer__2gBWv"};